module.exports = __webpack_public_path__ + "static/media/IN.ea718b41.svg";